const initialState = {
  screenWidth: 1920,
  screenHeight: 1080,
  collapsed: false, // 菜单收起
  theme: {
    colorPrimary: '#1677ff',
  }
}

export default initialState